module.exports = __webpack_public_path__ + "media/images/img_discount-b05386f54b0be06819dda1d43d578c7a.png";